<div class="header">
  <div class="container text-center">
    <h1 class="title fw-bold">{{ blog.title }}</h1>
    <p class="mt-3 lead">{{ blog.description }}</p>
  </div>
</div>

<div class="container my-5 blog-content" [innerHTML]="blog.htmlContent"></div>

<div class="text-center">
  <button (click)="visitStore()" class="btn btn-primary px-4 py-2 mt-4">{{ 'VISIT_STORE' | translate }}</button>
</div>
